(function () {
  if (window.__DNM_CART_SYNC_BOOTED__) return;
  window.__DNM_CART_SYNC_BOOTED__ = true;

  // ==============================
  // CONFIG
  // ==============================
  var GIFT_THRESHOLD_CENTS = 7500;          // $75.00
  var SHIP_THRESHOLD_CENTS = 10000;         // $100.00 (messaging/progress elsewhere)
  var GIFT_VARIANT_ID = '52194001223977';   // Mystery Gift

  // Cart-level add-ons (variants)
  var GIFT_LETTER_VARIANT_ID = '52194025636137'; // Handwritten Gift Letter
  var INSURANCE_VARIANT_ID   = '52429414924585'; // TODO: set Order Insurance variant id

  // Cart attributes (cart-level data)
  var ATTR = {
    gift_enabled: 'dnm_gift_letter_enabled',
    gift_from: 'dnm_gift_letter_from',
    gift_to: 'dnm_gift_letter_to',
    gift_message: 'dnm_gift_letter_message',

    insurance_choice: 'dnm_insurance_choice' // "on" | "off"
  };

  var cartInFlight = null;
  var cartCache = null;
  var lastSyncTime = 0;
  var MIN_SYNC_INTERVAL = 1500;

  // ==============================
  // LIGHTWEIGHT CART DRAWER REFRESH
  // ==============================
  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (typeof jQuery !== 'undefined') {
      try {
        jQuery(document).trigger('cart:refresh');
        jQuery(document).trigger('cart:updated');
        jQuery(document).trigger('ajaxCart:updated');
      } catch (e) {}
    }
  }

  // ==============================
  // HELPERS
  // ==============================
  function getCart(opts) {
    opts = opts || {};
    if (!opts.force && cartCache) return Promise.resolve(cartCache);
    if (cartInFlight) return cartInFlight;

    cartInFlight = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load cart.js');
        return res.json();
      })
      .then(function (cart) {
        cartCache = cart;
        return cart;
      })
      .catch(function () {
        return cartCache || { items: [], total_price: 0, attributes: {} };
      })
      .finally(function () {
        cartInFlight = null;
      });

    return cartInFlight;
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var format = window.money_format || '${{amount}}';
        return Shopify.formatMoney(cents, format);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function findItemByVariant(cart, variantId) {
    var id = String(variantId || '');
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === id) return items[i];
    }
    return null;
  }

  // Effective subtotal EXCLUDING:
  // - auto mystery gift
  // - cart-level add-ons (gift letter + insurance)
  function getEffectiveSubtotal(cart) {
    var total = 0;
    var giftId = String(GIFT_VARIANT_ID);
    var letterId = String(GIFT_LETTER_VARIANT_ID);
    var insId = String(INSURANCE_VARIANT_ID);

    (cart.items || []).forEach(function (item) {
      var vid = String(item.variant_id);
      if (vid === giftId) return;
      if (vid === letterId) return;
      if (vid === insId) return;
      total += item.line_price || 0;
    });

    return total;
  }

  function updateTotalPrice(cart) {
    var els = document.querySelectorAll('.js-total-price');
    if (!els.length) return;
    var formatted = money(cart.total_price || 0);
    els.forEach(function (el) { el.textContent = formatted; });
  }

  function updateCartPerks(cart) {
    try {
      var perks = document.querySelector('.cart-perks');
      if (!perks) return;

      var total = getEffectiveSubtotal(cart);
      var giftThreshold = GIFT_THRESHOLD_CENTS;
      var shipThreshold = SHIP_THRESHOLD_CENTS;

      var bar = perks.querySelector('.cart-perks__fill');
      if (bar && shipThreshold > 0) {
        var pct = Math.min(100, (total * 100) / shipThreshold);
        bar.style.width = pct + '%';
      }

      var giftReached = total >= giftThreshold;
      var shipReached = total >= shipThreshold;

      perks.classList.toggle('is-complete', shipReached);

      var giftLegend = perks.querySelector('.cart-perks__legend-item:nth-child(1)');
      var shipLegend = perks.querySelector('.cart-perks__legend-item:nth-child(2)');
      var giftMarker = perks.querySelector('.cart-perks__marker--gift');
      var shipMarker = perks.querySelector('.cart-perks__marker--ship');
      var msg = perks.querySelector('.cart-perks__message');

      if (giftLegend) giftLegend.classList.toggle('is-reached', giftReached);
      if (shipLegend) shipLegend.classList.toggle('is-reached', shipReached);
      if (giftMarker) giftMarker.classList.toggle('is-reached', giftReached);
      if (shipMarker) shipMarker.classList.toggle('is-reached', shipReached);

      if (msg) {
        if (total < giftThreshold) {
          msg.textContent = "You're " + money(giftThreshold - total) + ' away from your Mystery Gift';
        } else if (total < shipThreshold) {
          msg.textContent = 'Mystery Gift unlocked! You’re ' + money(shipThreshold - total) + ' away from Free Shipping';
        } else {
          msg.textContent = "You've unlocked your Mystery Gift + Free Shipping!";
        }
      }
    } catch (e) {}
  }

  function refreshUI(cart) {
    updateTotalPrice(cart);
    updateCartPerks(cart);
    syncCartAddonUI(cart);
  }

  function postForm(url, bodyParams) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: bodyParams.toString()
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t || 'Request failed'); });
      return res.json();
    });
  }

  function updateCartAttributes(attrs) {
    var body = new URLSearchParams();
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v === null || typeof v === 'undefined' || v === '') {
        // Clear attribute
        body.append('attributes[' + k + ']', '');
      } else {
        body.append('attributes[' + k + ']', String(v));
      }
    });

    return postForm('/cart/update.js', body).then(function (cart) {
      cartCache = cart;
      refreshUI(cart);
      refreshCartDrawer();
      return cart;
    });
  }

  function addVariant(variantId, qty, properties) {
    var body = new URLSearchParams();
    body.append('id', String(variantId));
    body.append('quantity', String(qty || 1));

    properties = properties || {};
    Object.keys(properties).forEach(function (k) {
      body.append('properties[' + k + ']', String(properties[k]));
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: body.toString()
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t || 'add.js failed'); });
      cartCache = null;
      refreshCartDrawer();
    });
  }

  function removeVariant(variantId) {
    var body = new URLSearchParams();
    body.append('updates[' + String(variantId) + ']', '0');

    return postForm('/cart/update.js', body).then(function (cart) {
      cartCache = cart;
      refreshUI(cart);
      refreshCartDrawer();
      return cart;
    });
  }

  // ==============================
  // CART ADD-ONS (Gift Letter + Insurance)
  // ==============================
  function getAddonRoot() {
    return document.querySelector('.dnm-cart-addons');
  }

  function setAddonOn(addonName, isOn) {
    var root = getAddonRoot();
    if (!root) return;
    var row = root.querySelector('.dnm-addon[data-addon="' + addonName + '"]');
    if (!row) return;
    row.classList.toggle('is-on', !!isOn);
  }

  function setAddonPrice(addonName, cents) {
    var el = document.querySelector('[data-addon-price="' + addonName + '"]');
    if (!el) return;
    if (typeof cents === 'number') el.textContent = '+' + money(cents);
    else el.textContent = '';
  }

  function setGiftLetterSummary(cart) {
    var el = document.querySelector('[data-gift-letter-summary]');
    if (!el) return;

    var a = (cart && cart.attributes) || {};
    var from = (a[ATTR.gift_from] || '').trim();
    var to = (a[ATTR.gift_to] || '').trim();
    var msg = (a[ATTR.gift_message] || '').trim();

    var bits = [];
    if (from) bits.push('From: ' + from);
    if (to) bits.push('To: ' + to);
    if (msg) bits.push('“' + msg.substring(0, 72) + (msg.length > 72 ? '…' : '') + '”');

    if (!bits.length) {
      el.style.display = 'none';
      el.textContent = '';
      return;
    }

    el.textContent = bits.join(' • ');
    el.style.display = '';
  }

  function setTotalHint(cart) {
    var hint = document.querySelector('[data-total-hint]');
    if (!hint) return;

    var hasInsurance = !!findItemByVariant(cart, INSURANCE_VARIANT_ID);
    var hasLetter = !!findItemByVariant(cart, GIFT_LETTER_VARIANT_ID);

    if (!hasInsurance && !hasLetter) {
      hint.style.display = 'none';
      hint.textContent = '';
      return;
    }

    var parts = [];
    if (hasInsurance) parts.push('Protected order');
    if (hasLetter) parts.push('Gift-ready');

    hint.textContent = parts.join(' • ') + ' — you’re all set.';
    hint.style.display = '';
  }

  function syncCartAddonUI(cart) {
    var root = getAddonRoot();
    if (!root) return;

    var letterItem = findItemByVariant(cart, GIFT_LETTER_VARIANT_ID);
    var insuranceItem = findItemByVariant(cart, INSURANCE_VARIANT_ID);

    setAddonOn('gift_letter', !!letterItem);
    setAddonOn('insurance', !!insuranceItem);

    setAddonPrice('gift_letter', letterItem ? (letterItem.final_line_price || letterItem.line_price || 0) : null);
    setAddonPrice('insurance', insuranceItem ? (insuranceItem.final_line_price || insuranceItem.line_price || 0) : null);

    var editBtn = root.querySelector('[data-gift-letter-edit]');
    if (editBtn) editBtn.style.display = letterItem ? '' : 'none';

    var badge = root.querySelector('[data-insurance-badge]');
if (badge) badge.style.display = '';


    setGiftLetterSummary(cart);
    setTotalHint(cart);
  }

  function ensureInsuranceDefault(cart) {
    if (!INSURANCE_VARIANT_ID || INSURANCE_VARIANT_ID === '00000000000000') return Promise.resolve();

    var a = (cart && cart.attributes) || {};
    var choice = (a[ATTR.insurance_choice] || '').toLowerCase(); // on/off/empty

    // If customer explicitly opted out, do nothing.
    if (choice === 'off') return Promise.resolve();

    // Default is ON (if no choice yet, we treat as on).
    var has = !!findItemByVariant(cart, INSURANCE_VARIANT_ID);
    if (has) {
      // ensure attribute reflects state
      if (choice !== 'on') return updateCartAttributes((function () {
        var o = {}; o[ATTR.insurance_choice] = 'on'; return o;
      })());
      return Promise.resolve();
    }

    // Add insurance + set attribute on
    return addVariant(INSURANCE_VARIANT_ID, 1, { _dnm_cart_addon: 'insurance' })
      .then(function () { return getCart({ force: true }); })
      .then(function (fresh) {
        return updateCartAttributes((function () {
          var o = {}; o[ATTR.insurance_choice] = 'on'; return o;
        })()).then(function(){ return fresh; });
      })
      .catch(function () {});
  }

  // Gift Letter modal (cart-level)
  function initGiftLetterModal() {
    var modal = document.getElementById('gift-letter-modal');
    var form = modal ? modal.querySelector('#gift-letter-form') : null;
    if (!modal || !form) return;

    function openModal(prefillFromCart) {
      document.body.style.overflow = 'hidden';
      modal.classList.add('is-open');

      if (!prefillFromCart) {
        if (form.elements.from) form.elements.from.value = '';
        if (form.elements.to) form.elements.to.value = '';
        if (form.elements.message) form.elements.message.value = '';
        return;
      }

      getCart().then(function (cart) {
        var a = (cart && cart.attributes) || {};
        if (form.elements.from) form.elements.from.value = a[ATTR.gift_from] || '';
        if (form.elements.to) form.elements.to.value = a[ATTR.gift_to] || '';
        if (form.elements.message) form.elements.message.value = a[ATTR.gift_message] || '';
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-gift-letter-edit]')) {
        e.preventDefault();
        openModal(true);
        return;
      }
      if (e.target.closest('.gift-letter-close') || e.target.classList.contains('gift-letter-backdrop')) {
        closeModal();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var data = new FormData(form);
      var from = (data.get('from') || '').trim().substring(0, 100);
      var to = (data.get('to') || '').trim().substring(0, 100);
      var msg = (data.get('message') || '').trim().substring(0, 300);

      if (!from || !msg) return;

      // Save attributes + ensure letter variant exists
      getCart({ force: true }).then(function (cart) {
        var hasLetter = !!findItemByVariant(cart, GIFT_LETTER_VARIANT_ID);

        var attrs = {};
        attrs[ATTR.gift_enabled] = 'yes';
        attrs[ATTR.gift_from] = from;
        attrs[ATTR.gift_to] = to;
        attrs[ATTR.gift_message] = msg;

        var chain = updateCartAttributes(attrs);

        if (!hasLetter) {
          chain = chain.then(function () {
            return addVariant(GIFT_LETTER_VARIANT_ID, 1, { _dnm_cart_addon: 'gift_letter' });
          }).then(function () { return getCart({ force: true }); })
            .then(function (fresh) { refreshUI(fresh); });
        }

        return chain.then(function () {
          closeModal();
        });
      }).catch(function () {
        alert('Failed to save gift letter. Please try again.');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) modal.classList.remove('is-open');
    });

    // expose for toggle
    window.__dnmOpenGiftLetterModal = function (prefill) { openModal(!!prefill); };
  }

  function initCartAddonToggles() {
    var busy = false;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-addon-toggle]');
      if (!btn) return;

      var addon = btn.getAttribute('data-cart-addon-toggle');
      if (!addon) return;

      e.preventDefault();
      if (busy) return;

      busy = true;

      getCart({ force: true }).then(function (cart) {
        if (addon === 'gift_letter') {
          var hasLetter = !!findItemByVariant(cart, GIFT_LETTER_VARIANT_ID);

          // Turning OFF
          if (hasLetter) {
            // Clear attributes + remove variant
            return updateCartAttributes((function () {
              var o = {};
              o[ATTR.gift_enabled] = '';
              o[ATTR.gift_from] = '';
              o[ATTR.gift_to] = '';
              o[ATTR.gift_message] = '';
              return o;
            })())
              .then(function () { return removeVariant(GIFT_LETTER_VARIANT_ID); })
              .then(function (fresh) { refreshUI(fresh); });
          }

          // Turning ON -> open modal to capture message first
          if (window.__dnmOpenGiftLetterModal) window.__dnmOpenGiftLetterModal(false);
          return;
        }

        if (addon === 'insurance') {
          if (!INSURANCE_VARIANT_ID || INSURANCE_VARIANT_ID === '00000000000000') {
            alert('Order Insurance variant id is not set yet.');
            return;
          }

          var hasIns = !!findItemByVariant(cart, INSURANCE_VARIANT_ID);

          // Toggle OFF (persist choice)
          if (hasIns) {
            return updateCartAttributes((function () {
              var o = {}; o[ATTR.insurance_choice] = 'off'; return o;
            })())
              .then(function () { return removeVariant(INSURANCE_VARIANT_ID); })
              .then(function (fresh) { refreshUI(fresh); });
          }

          // Toggle ON (persist choice)
          return addVariant(INSURANCE_VARIANT_ID, 1, { _dnm_cart_addon: 'insurance' })
            .then(function () { return getCart({ force: true }); })
            .then(function (fresh) {
              return updateCartAttributes((function () {
                var o = {}; o[ATTR.insurance_choice] = 'on'; return o;
              })()).then(function(){ return fresh; });
            })
            .then(function (fresh) { refreshUI(fresh); });
        }
      }).catch(function () {})
        .finally(function () { busy = false; });
    });
  }

  // ==============================
  // FREE MYSTERY GIFT SYNC (same as before, but subtotal excludes add-ons now)
  // ==============================
  function initFreeGiftSync() {
    if (!GIFT_THRESHOLD_CENTS || !GIFT_VARIANT_ID) return;

    var syncing = false;
    var debounceTimer = null;

    function findGiftItem(cart) {
      return findItemByVariant(cart, GIFT_VARIANT_ID);
    }

    function addGift() {
      var body = new URLSearchParams();
      body.append('id', GIFT_VARIANT_ID);
      body.append('quantity', '1');
      body.append('properties[_auto_gift]', 'true');

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json'
        },
        body: body.toString()
      }).then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
        cartCache = null;
        refreshCartDrawer();
      });
    }

    function removeGift() {
      var body = new URLSearchParams();
      body.append('updates[' + GIFT_VARIANT_ID + ']', '0');

      return postForm('/cart/update.js', body).then(function (cart) {
        cartCache = cart;
        refreshCartDrawer();
        return cart;
      });
    }

    function syncFreeGift() {
      var now = Date.now();
      if (now - lastSyncTime < MIN_SYNC_INTERVAL) return Promise.resolve();
      lastSyncTime = now;

      if (syncing) return Promise.resolve();
      syncing = true;

      return getCart({ force: true })
        .then(function (cart) {
          var effectiveTotal = getEffectiveSubtotal(cart);
          var shouldHaveGift = effectiveTotal >= GIFT_THRESHOLD_CENTS;
          var hasGift = !!findGiftItem(cart);

          if (shouldHaveGift && !hasGift) {
            return addGift()
              .then(function () { return getCart({ force: true }); })
              .then(function (fresh) { refreshUI(fresh); });
          }

          if (!shouldHaveGift && hasGift) {
            return removeGift()
              .then(function () { return getCart({ force: true }); })
              .then(function (fresh) { refreshUI(fresh); });
          }

          refreshUI(cart);
        })
        .catch(function () {})
        .finally(function () { syncing = false; });
    }

    setTimeout(syncFreeGift, 300);

    var cartInner = document.querySelector('.js-cart-inner');
    if (cartInner && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(syncFreeGift, 900);
      });
      observer.observe(cartInner, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      var target = e.target.closest('.js_plus, .js_minus, .js_qty, .js-remove-item, .remove');
      if (target) setTimeout(syncFreeGift, 600);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        setTimeout(syncFreeGift, 900);
      }
    });

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (target && (target.classList.contains('js_qty') || target.name === 'quantity')) {
        setTimeout(syncFreeGift, 600);
      }
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    try {
      initGiftLetterModal();
      initCartAddonToggles();

      // initial sync
      getCart({ force: true }).then(function (cart) {
        refreshUI(cart);
        return ensureInsuranceDefault(cart);
      }).then(function () {
        return getCart({ force: true });
      }).then(function (fresh) {
        refreshUI(fresh);
      }).catch(function () {});

      initFreeGiftSync();
    } catch (e) {
      console.error('[Cart Sync] Init error:', e);
    }
  });
})();
